// Port of BivouacEngine/BivouacLog.swift: logging shim (see src/nav/navigationLog.ts for the sink).
//
// Only counts and unusual input are logged — never coordinates — so that logs cannot reveal where a hiker is or plans
// to sleep.

import { makeLogger } from '../nav/navigationLog';

/** Loggers used by the BivouacEngine module. */
export const BivouacLog = {
  logger: makeLogger('BivouacEngine'),
};
